import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';    
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';           
import { Rank } from '@ascschool/model/category/rank.model';
import { DegreeService } from '@ascschool/services/category/degree.service';
import { Degree } from '@ascschool/model/category/degree.model';
import { SystemUserService } from '@ascschool/services/user/system-user.service';
import { GroupService } from '@ascschool/services/user/group.service';
import { Observable } from 'rxjs';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-phan-nhom-quyen',
  templateUrl: './phan-nhom-quyen.component.html',
  styleUrls: ['./phan-nhom-quyen.component.scss']
})
export class PhanNhomQuyenComponent implements OnInit {
  @Input() lstIdGroup: any;
  userGroupForm: FormGroup;
  getGroupACFn : (value: any) => Observable<any>;
  groupSubscription : any;
  groupControl = new FormControl();
  commonFilter = new CommonFilter();
  isEditMode = false;
  degreeItem = new Degree();
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup; 
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    private route: ActivatedRoute,
    public utilsService: UtilsService,
    private systemUserService : SystemUserService,
    private groupService : GroupService,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit() {
    this.lstIdGroup; 
    this.loadGroup(); 
  }
  loadGroup() {
    this.getGroupACFn = (value: any) => this.groupService.GetSelectPagingCreateByGroup({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.groupName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.groupSubscription) this.groupSubscription = this.groupControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.commonFilter, 'GroupId', this.groupControl.value);
    });
  }
  changeGroup(control: FormControl) {
    this.groupControl = control;
  }
  Update(){
    if(this.groupControl.value && this.groupControl.value != null){ 
      this.systemUserService.updateMultiple({groupId: this.groupControl.value.id, listSystemUserId: this.lstIdGroup}).subscribe((res)=>{
        if(res.statusCode == 0){
          this.utilsService.notifyResponse(res);
          this.close();
        }
        else{
          this.utilsService.notifyResponse(res);
        }
      })
    }else{
      this.msg.warning('Vui lòng chọn nhóm quyền');
    }
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
   
}
